import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcMms } from "react-icons/fc";
import SimpleButton from "../../Components/layouts/simple_button";

const ViewSubsidyNew = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/subsidy/view-subsidy/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          // console.log(data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcMms></FcMms> View Subsidy Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title"> View Subsidy Details</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Name :</label>
                  <div className="w-100 col">
                    {data?.name.toUpperCase() || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Contact Number :
                  </label>
                  <div className="w-100 col">{data?.phoneNo || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Farmer ID :</label>
                  <div className="w-100 col">{data?.farmerId.toUpperCase() || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Employer Status :
                  </label>
                  <div className="w-100 col">{data?.empStatus.toUpperCase() || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">State :</label>
                  <div className="w-100 col">
                    {data?.state.toUpperCase() || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">District :</label>
                  <div className="w-100 col">
                    {data?.district.toUpperCase() || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Taluka :</label>
                  <div className="w-100 col">
                    {data?.taluka.toUpperCase() || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Village Name</label>
                  <div className="w-100 col">
                    {data?.vName.toUpperCase() || "N/A"}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Subsidies :</label>
                  <div className="w-100 col">
                    <ul>
                      {data?.subsidy.map((data, index) => {
                        return <li key={index}>{data}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              )} */}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewSubsidyNew;
